import * as React from 'react';
import { type MouseEvent } from 'react';
import { useLatestRef } from '@epihub/web/src/hooks/useLatestRef';

export function useStopPropagation<F extends (evt: MouseEvent) => any>(f?: F) {
  const fRef = useLatestRef(f);
  return React.useCallback((evt: MouseEvent) => {
    evt.stopPropagation();
    evt.preventDefault();
    return fRef.current?.(evt);
  }, [fRef]);
}

export function stopPropagation(evt: any) {
  if (evt && typeof evt.stopPropagation === 'function') {
    evt?.stopPropagation();
  }
  if (evt && typeof evt.preventDefault === 'function') {
    evt?.preventDefault();
  }
}
